var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 29,
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90034 14.896L8.73494 19.9617L13.8007 21.7963L8.73494 23.6309L6.90034 28.6967L5.06573 23.6309L0 21.7963L5.06573 19.9617L6.90034 14.896Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90034 14.896L8.73494 19.9617L13.8007 21.7963L8.73494 23.6309L6.90034 28.6967L5.06573 23.6309L0 21.7963L5.06573 19.9617L6.90034 14.896Z",
    fill: "url(#paint0_linear_318_387)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5522 0L12.9879 6.87421L19.8621 9.30998L12.9879 11.7457L10.5522 18.62L8.1164 11.7457L1.24219 9.30998L8.1164 6.87421L10.5522 0Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5522 0L12.9879 6.87421L19.8621 9.30998L12.9879 11.7457L10.5522 18.62L8.1164 11.7457L1.24219 9.30998L8.1164 6.87421L10.5522 0Z",
    fill: "url(#paint1_linear_318_387)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2573 19.1654L15.0158 18.8383L11.8128 19.434L13.7168 16.7903L14.8024 13.7185L16.1399 16.6893L18.2573 19.1654Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2573 19.1654L15.0158 18.8383L11.8128 19.434L13.7168 16.7903L14.8024 13.7185L16.1399 16.6893L18.2573 19.1654Z",
    fill: "url(#paint2_linear_318_387)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_387",
    x1: 6.90034,
    y1: 14.896,
    x2: 6.90034,
    y2: 28.6967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8604A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#E8604A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_387",
    x1: 10.5522,
    y1: 0,
    x2: 10.5522,
    y2: 18.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8604A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#E8604A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_387",
    x1: 18.2573,
    y1: 19.1654,
    x2: 11.6577,
    y2: 15.7132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8604A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#E8604A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.df1aaeeb8382ce58180f2790517eab37.svg";
export { ForwardRef as ReactComponent };